module.exports = __webpack_public_path__ + "img/image8.7bc3f70a.png";